import { render, staticRenderFns } from "./ReglamentoCard.vue?vue&type=template&id=5842872e&scoped=true"
import script from "./ReglamentoCard.vue?vue&type=script&lang=js"
export * from "./ReglamentoCard.vue?vue&type=script&lang=js"
import style0 from "./ReglamentoCard.vue?vue&type=style&index=0&id=5842872e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5842872e",
  null
  
)

export default component.exports